export default "__VITE_ASSET__pXYOC$x5__"